import {app} from "@tva/app";
import {downgradeComponent, downgradeInjectable} from "@angular/upgrade/static";
import {SearchDetailsNotificationService} from "./services/search-details-notification.service";

import * as angular from "angular";
import {StudentCreTrackingComponent} from "@tva/ng-migration/student/components/student-cre-tracking/student-cre-tracking.component";

app.factory(schoolwork12.app.student.services.studentSearchDetailsNotification, downgradeInjectable(SearchDetailsNotificationService));

app.directive(
    "appStudentCreTracking",
    downgradeComponent({
        component: StudentCreTrackingComponent,
    }) as angular.IDirectiveFactory
);
